import * as Yup from 'yup';

const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  smsPhNumber: '',
};
const VALIDATION_SCHEMA = (pageLanguageContents) => {
  let schemaAttributes
  schemaAttributes = {
    firstName: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[6]?.FirstNameReq),
    lastName: Yup.string().trim().required(pageLanguageContents?.ErrorValidations[7]?.LastNameReq),
    email: Yup.string()
      .email(pageLanguageContents?.ErrorValidations[8]?.ValidEmail)
      .required(pageLanguageContents?.ErrorValidations[9]?.EmailReq),
    // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,pageLanguageContents?.ErrorValidations[8]?.ValidEmail),
    smsPhNumber: Yup.string().matches(/^\D*(\d\D*){10}\D*$/, 'Phone Number is invalid.')
      .test('hasNonZero', 'Phone Number is invalid.', function (value) {
        if (value) {
          const regex = /[1-9]/;
          return regex.test(value);
        }
        return true;
      }),
  }
  return Yup.object().shape(schemaAttributes);
}

export { INITIAL_VALUES, VALIDATION_SCHEMA };
